<template>
  <div>
    <ContentPage headerText="Testimonials">
      <p>
        What our clients say about working with Rococo Painters:
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="testimonials">
          <blockquote
            v-for="(quote, index) in testimonials"
            :key="index"
            class="testimonial"
          >
            <p>{{ quote.body }}</p>
            <footer>— {{ quote.author }}</footer>
          </blockquote>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'

export default {
  name: 'testimonials',
  metaInfo: {
    title: 'Testimonials',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'What our clients say about working with Rococo Painters — quality preparation and finish on every job.'
      }
    ]
  },
  components: {
    ContentPage
  },
  data () {
    return {
      testimonials: [
        {
          body: 'We met this morning and we are really pleased with the windows, a very good job. We would not hesitate to recommend you in the future.',
          author: 'Sarah Jane Cheeseman, Southwold'
        },
        {
          body: 'Thank you for a wonderful job. Brilliant customer service from start to finish, the whole process was a pleasure. I really appreciate all your hard work and attention to detail. I would very much recommend you.',
          author: 'John Waterman, Wells-next-the-Sea'
        },
        {
          body: 'Thanks Matthew, you have done an amazing job. The windows look fantastic, and the house now looks superb.',
          author: 'John Paul, Southwold'
        },
        {
          body: 'I just want to thank the whole team for delivering a great service and going to great lengths to ensure the project was finished on time and to a very high standard. The interior of our house looks great, I feel like we have a new home.',
          author: 'Sue Turn, Cambridge'
        },
        {
          body: 'The team at Rococo have completed lots of work for me over the years and I highly recommend them. They have done everything from painting the whole interior of my apartment to restoring all the windows and doors. Very professional, with great communication throughout.',
          author: 'Margot, North Norfolk'
        },
        {
          body: 'We had our windows and doors painted by Rococo and they did a superb job. They were on time, very hard-working, and extremely thorough in stripping back the timber and repainting it. They even helped with colour choices and matching our existing paint. Thank you.',
          author: 'Kevin, Norwich'
        },
        {
          body: 'The front door looks amazing. I am so pleased with it. The team gave very good advice in recommending eggshell rather than gloss. I am very happy with the work and with how clean and tidy the team were.',
          author: 'Amy, Stowmarket'
        },
        {
          body: 'I would highly recommend Rococo to anyone looking for a professional job. From start to finish, the advice was excellent and the team were very knowledgeable about paints and colours throughout the process.',
          author: 'Sue, London'
        },
        {
          body: 'Thanks Matthew. You have certainly added something special to the house through your careful work on the original 1890 windows, which really are its most attractive feature. We cannot recommend you highly enough.',
          author: 'Arnold, Norwich'
        },
        {
          body: 'Thank you to all the staff at Rococo. I am very pleased with the work carried out on my historic property and would highly recommend you.',
          author: 'Peter, London'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.testimonials {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.testimonial {
  border-left: 5px solid $clr-theme-black;
  background-color: #f5f5f5;
  padding: 1.5rem 2rem;
  margin: 0;
  box-shadow: $shadow;
  border-radius: 4px;

  p {
    margin: 0;
    font-style: italic;
  }

  footer {
    margin-top: 1rem;
    font-weight: 600;
    color: $clr-theme-black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Testimonials.vue